import React from 'react';
import { MODULES } from './config/modules';

export default function Home() {
  const styles = {
    modulesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
      gap: '24px',
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '40px 20px'
    },
    moduleCard: {
      background: '#1e293b',
      borderRadius: '12px',
      padding: '32px',
      border: '1px solid #334155',
      transition: 'all 0.2s ease',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '140px'
    },
    moduleCardLocked: {
      opacity: 0.6,
      background: '#0f172a',
      border: '1px solid #1e293b'
    },
    levelBadge: {
      position: 'absolute',
      top: '16px',
      right: '16px',
      background: '#3b82f6',
      borderRadius: '6px',
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1rem',
      fontWeight: '600',
      color: 'white'
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    },
    moduleIcon: {
      fontSize: '2.25rem',
      width: '56px',
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#334155',
      borderRadius: '10px',
      flexShrink: 0
    },
    cardText: {
      flex: 1
    },
    moduleTitle: {
      fontSize: '2rem',
      fontWeight: '600',
      color: '#ffffff',
      lineHeight: '1.4',
      margin: '0 0 6px 0'
    },

    lockedText: {
      background: '#374151',
      color: '#9ca3af',
      padding: '8px 16px',
      borderRadius: '8px',
      fontSize: '0.875rem',
      fontWeight: '500',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      border: '1px solid #4b5563',
      opacity: 0.8
    },
    moduleDescription: {
      background: '#334155',
      color: '#cbd5e1',
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '1.1rem',
      fontWeight: '400',
      lineHeight: '1.4',
      border: '1px solid #475569',
      opacity: 0.9
    }
  };

  const getLevelNumber = moduleId => {
    const levelMap = {
      'part-1': 1,
      'part-2': 2,
      'part-3': 3,
      'part-4': 4,
      'part-5': 5
    };
    return levelMap[moduleId] || 1;
  };

  return (
    <>
      {/* Grille des modules */}
      <div style={styles.modulesGrid}>
        {MODULES.map(module => (
          <div
            key={module.id}
            style={{
              ...styles.moduleCard,
              ...(module.visible ? {} : styles.moduleCardLocked)
            }}
            onClick={() => {
              if (module.visible) {
                window.location.hash = `#/${module.id}`;
              }
            }}
            onMouseEnter={e => {
              if (module.visible) {
                e.currentTarget.style.transform =
                  'translateY(-12px) scale(1.03)';
                e.currentTarget.style.boxShadow =
                  '0 30px 80px rgba(0, 0, 0, 0.4)';
                e.currentTarget.style.border =
                  '1px solid rgba(255, 255, 255, 0.3)';

                // Effet sur l'icône
                const icon = e.currentTarget.querySelector('[data-icon]');
                if (icon) icon.style.transform = 'scale(1.1) rotate(5deg)';
              }
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow =
                '0 20px 60px rgba(0, 0, 0, 0.3)';
              e.currentTarget.style.border =
                '1px solid rgba(255, 255, 255, 0.15)';

              // Reset de l'icône
              const icon = e.currentTarget.querySelector('[data-icon]');
              if (icon) icon.style.transform = 'scale(1) rotate(0deg)';
            }}>
            {/* Badge de niveau */}
            <div style={styles.levelBadge}>{getLevelNumber(module.id)}</div>

            {/* Contenu de la carte */}
            <div style={styles.cardContent}>
              {/* Header avec icône et texte */}
              <div style={styles.cardHeader}>
                <div style={styles.moduleIcon} data-icon>
                  {module.icon}
                </div>
                <div style={styles.cardText}>
                  <h3 style={styles.moduleTitle}>{module.title}</h3>
                </div>
              </div>

              {/* Description */}
              <div style={styles.moduleDescription}>{module.description}</div>

              {/* Bouton d'accès */}
              {!module.visible && (
                <span style={styles.lockedText} role="img" aria-label="Lock">
                  Verrouillé 🔒
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
